import React from 'react';
import PropTypes from 'prop-types';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrSeparator from 'client/components/SrSeparator';
import SrBox from 'client/components/SrBox';

const SrDividerLine = ({ text, textProps, alignItems, height }) => (
  <SrFlex justifyContent="center" alignItems={alignItems}>
    <SrBox width="85px" position="relative" top="14px">
      <SrSeparator style={{ height }} />
    </SrBox>
    <SrBox padding="0 10px">
      <SrText {...textProps}>{text}</SrText>
    </SrBox>
    <SrBox width="85px" position="relative" top="14px">
      <SrSeparator />
    </SrBox>
  </SrFlex>
);

SrDividerLine.propTypes = {
  text: PropTypes.string.isRequired,
  textProps: PropTypes.object,
  alignItems: PropTypes.string,
  height: PropTypes.string,
};

SrDividerLine.defaultProps = {
  textProps: {
    size: '16',
    color: 'greyMonochrome',
    font: 'whitney',
    weight: '500',
  },
  alignItems: 'baseline',
  height: '1px',
};

SrDividerLine.displayName = 'SrDividerLine';

export default SrDividerLine;
